import { gql } from '@apollo/client';

export const DOCUMENT_CLAUSE_DELETED = gql`
  subscription documentClauseDeleted {
    documentClauseDeleted {
      clauseId
    }
  }
`;
